import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaNt020 {

  // GET parameters
  export namespace Get {
    export interface Request {
      query: {
        offset: number,
        limit: number,
        coursePlan: string[]
      }
    }

    interface ResponseNode {
      noticeId: number,
      title: string,
      deliveryDate: string,
      unreadFlag: number,
      importantFlag: number
    }

    export type Response = ResponseNode[]
  }

  // API Path
  const path: string = '/ta/notices'

  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {

    public get<R>(params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler:ApiResponseHandler<ResponseError, R>)
      : Promise<R | null> {

      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = [
        {
          noticeId: 0,
          title: '',
          deliveryDate: '',
          unreadFlag: 1,
          importantFlag: 0
        }
      ]
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: ''
        }
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample)

      // dummyserverでの確認はこちらを使用してください
      // offsetで決められた範囲を取得する振る舞いを再現しています
      // return this.callbackWrapper<Get.Response, ResponseError, R>(
      //   api.get<Get.Response>(path, { params: params.query }),
      //   successHandler,
      //   errorHandler,
      //   validationSample,
      //   validationErrorSample)
      //   .then((val:any) => {
      //     return val ? val.slice(params.query.offset, params.query.limit + params.query.offset) : []
      //   })
    }
  }
}